export const NEW_MAIN_PAGE_EXPERIMENT = 'bx_mobile_bx687_new_mainpage';

export const EXPERIMENTS: string[] = [NEW_MAIN_PAGE_EXPERIMENT];
